export default function ProgressBar({ phaseIndex, totalPhases, questionIndex, totalInPhase, personalizing }) {
  const completed = personalizing ? 0 : phaseIndex + questionIndex / Math.max(1, totalInPhase);
  const pct = Math.min(100, (completed / totalPhases) * 100);
  return (
    <div className="fixed top-0 inset-x-0 z-40 bg-white/85 backdrop-blur-md border-b kt-line" data-testid="progress-bar">
      <div className="max-w-md mx-auto px-6 py-3">
        <div className="flex items-center justify-between text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-2">
          <span data-testid="phase-label">
            {personalizing ? "Personalizing" : `Step ${phaseIndex + 1} / ${totalPhases}`}
          </span>
          <span>{Math.round(pct)}%</span>
        </div>
        <div className="h-1 w-full bg-[#F3F3F3] rounded-full overflow-hidden">
          <div className="h-full bg-[#D8C4A5] transition-all duration-500" style={{ width: `${pct}%` }} data-testid="progress-fill" />
        </div>
      </div>
    </div>
  );
}
